import { generateLabelsAndValues } from "../utils/helperFunctions";
import { MapRejectionCategory } from "./Constants";

export const CERTIFICATE_STATUS_GT_QT = {
    SUCCESSFUL: 1,
    // COMPLETED: 6,
    ACCEPTED: 4,
    REJECTED: 3,
    // APPLICATION_REJECTED: 5,
    SELFCHECK: 2,
    INCOMPLETE_DOCUMENT: 14,
    DEREGISTERED: 13,
    PENDING: 10,
    PENDING_FOR_BOARD_DECISION: 11,
};

export const CERTIFICATE_STATUS_ALL = {
    SUCCESSFUL: 1,
    // COMPLETED: 6,
    SELFCHECK: 2,
    REJECTED: 3,
    ACCEPTED: 4,
    // APPLICATION_REJECTED: 5,
    // PENDING_APPROVAL_FOR_ASSESSMENT: 7,
    READY_FOR_ASSESSMENT: 8,
    ASSESSMENT_SUCCESSFUL: 9,
    PENDING: 10,
    PENDING_FOR_BOARD_DECISION: 11,
    // PENDING_APPROVAL_FOR_RENEWAL: 12,
    DEREGISTERED: 13,
    INCOMPLETE_DOCUMENT: 14,
    REFUND: 15,
    CANCELLED: 16,
    PENDING_ENDORSEMENT: 17,
    REFUND_SUCCESS: 18,
    SELFCHECK_SUBMITTED: 19,
    NO_RESPONSE: 20,
    ALL: 21,
    REMOVAL_DEATH: 22,
    ASSESSMENT_FAILED: 23,
    ADDITIONAL_REVIEW_CHANGE_FIELD: 24,
    ADDITIONAL_REVIEW_ASSESSMENT: 25,
    QUEUE_FOR_ASSESSMENT: 26,
    ASSESSMENT_SCHEDULED: 27,
};

export const REJECTED_REASON = {
    QUALIFICATION_DOES_NOT_FULFIL_MINIMUM_REQUIREMENT: 1,
    YOUR_AREA_OF_EXPERTISE_DOES_NOT_LISTED_UNDER_THE_23_FIELDS_OF_TECHNOLOGY: 2,
    WORK_EXPERIENCE_IS_IRRELEVANT: 3,
    NOT_COVER_TECHNICAL_AND_TECHNOLOGY_SERVICES: 4,
    OTHERS_SECRETARIAT_CAN_WRITE_THE_REASON_MANUALLY: 5,
};

export function generateRejectionReasonOptions() {
    return Object.keys(REJECTED_REASON).map((key) => ({
        label: MapRejectionCategory[REJECTED_REASON[key]],
        value: REJECTED_REASON[key],
    }));
}
export const rejected_reasons_label_values = generateRejectionReasonOptions();

export const APPEAL_STATUS = {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
    PENDING_FOR_APPEAL_BOARD_DECISION: 4
};
